import React from 'react';
import LegalLayout from './LegalLayout';

const Terms = () => {
    return (
        <LegalLayout title="Terms & Conditions" lastUpdated="30th Jan 2026">
            <p>These Terms and Conditions (“Terms”) govern your access to and use of Trend Ads and related websites, apps, dashboards, and services (collectively, the “Service”) operated by Trendads.ai (“Trend Ads,” “we,” “us,” or “our”).</p>
            <p>By accessing or using the Service, you agree to these Terms. If you do not agree, do not use the Service.</p>

            <div className="legal-alert">
                IF YOU DO NOT ACCEPT THESE TERMS AND CONDITIONS, YOU MUST IMMEDIATELY STOP USING THE WEBSITE.
            </div>

            <h2>1) Who the Service is for</h2>
            <p>You must be at least 18 years old (or the age of majority where you live) and legally able to form a contract. If you use the Service on behalf of a company or organization, you represent that you have authority to bind that entity.</p>

            <h2>2) Service overview</h2>
            <p>Trend Ads provides a platform that may allow:</p>
            <ul>
                <li>Advertisers to create, manage, and distribute campaigns; and</li>
                <li>Viewers/Users to view advertising content and, where offered, receive rewards for eligible interactions.</li>
            </ul>

            <h2>3) User accounts and security</h2>
            <p>You may need to create an account or connect a digital wallet. You are responsible for all activity on your account. Keep your credentials and private keys secure. We are not responsible for any loss resulting from unauthorized access to your account or wallet.</p>

            <h2>4) Prohibited conduct</h2>
            <p>You agree NOT to:</p>
            <ul>
                <li>Use bots, scripts, or automation to simulate ad views or interactions.</li>
                <li>Bypass security, geofencing, or anti-fraud measures.</li>
                <li>Post or distribute illegal, hateful, or harmful content via our Service.</li>
                <li>Interrupt or damage the technical operation of the platform.</li>
            </ul>

            <h2>5) Advertising content</h2>
            <p>Advertisers are solely responsible for compliance with laws, regulations, and industry standards regarding their ads. We reserve the right to reject, pause, or remove any ad for any reason at our discretion.</p>

            <h2>6) Rewards and payments (if applicable)</h2>
            <p>Rewards are not guaranteed and are subject to availability, verification, and eligibility. We may withhold or claw back rewards if we suspect fraud or technical errors. Taxes are your sole responsibility.</p>

            <h2>7) Intellectual property</h2>
            <p>All content and software on the Service are owned by Trend Ads or its licensors. You are granted a limited, non-exclusive license to use the Service as intended. You may not copy, modify, or reverse-engineer our platform.</p>

            <h2>8) Termination</h2>
            <p>We may suspend or terminate your access to the Service at any time, without notice, for conduct that we believe violates these Terms or is otherwise harmful to other users or our business.</p>

            <h2>9) Disclaimer of warranties</h2>
            <p>The Service is provided “as is.” We disclaim all warranties, express or implied, including fitness for a particular purpose and non-infringement.</p>

            <h2>10) Limitation of liability</h2>
            <p>Trend Ads is not liable for indirect, incidental, or consequential damages (including loss of profits) arising from your use of the Service.</p>

            <h2>11) Governing law</h2>
            <p>These Terms are governed by the laws of our jurisdiction of incorporation, without regard to conflict of law principles.</p>

            <h2>12) Changes to terms</h2>
            <p>We may update these Terms from time to time. Your continued use of the Service after changes are posted constitutes acceptance of the new Terms.</p>

            <h2>13) Contact</h2>
            <p>Questions? Contact us at support@trendcreator.io</p>
        </LegalLayout>
    );
};

export default Terms;
